import _ from 'lodash'
import ChartAccessoryWidgetView from 'scoreboard/dashboards/widgets/chart/chart-accessory-widget-view'
import ColorLegend from 'scoreboard/charts/color-legend'
import template from './chart-color-legend-widget-view.hbs'

const ChartColorLegendWidgetView = ChartAccessoryWidgetView.extend({
	className: 'widget chart-color-legend',

	/**
	 * @type {ChartColorLegendModel}
	 */
	model: null,

	accessoryTemplate: template,

	/**
	 * @override
	 */
	renderContent () {
		let chartWob = this._findChartWob()
		let chart = chartWob.widget.chart
		let legendType = chart.get('legends')[0].legendType

		if (chart.hasError()) {
			this.renderError()
			return
		}
		this.showContent(true)

		this.colorLegend = new ColorLegend({
			chart,
			labels: true,
			legendType
		})
		this.$('.panel-content').empty().append(this.colorLegend.el)
		this.colorLegend.render()
		this.colorLegend.on('emphasize deemphasize', this.emphasize.bind(this))

		this.fitWobToContent(this.firstRender)
		this.firstRender = false
	},

	emphasize: function (seriesId) {
		let chartWob = this._findChartWob()
		const chartWidgetView = _.find(this.canvas.views, v =>
			v.model === chartWob).view
		chartWidgetView.renderChart(false, seriesId)
	},

	/**
	 * @override
	 */
	removeFromChartWidget: function() {
		var chartWob = this._findChartWob()
		if (!chartWob) return

		const legend = chartWob.widget.chart.get('legends')[0]
		const value = legend.legendType
		if (value != 'none') {
			legend.legendType = 'none'
			let updateChart = () => {
				chartWob.widget.chart.set('legends', [legend])
			}

			if (this.canvas.history) {
				this.canvas.history.quietly(updateChart)
			} else {
				updateChart()
			}
		}
	},

	/**
	 * @override
	 */
	getWidgetContent: function() {
		return this.$('.chart-color-legend')[0]
	},

	/**
	 * @override
	 */
	defaultFit: function() {
		return { height: true, width: true }
	},

	remove: function() {
		ChartAccessoryWidgetView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.colorLegend], 'remove')
	}
})

export default ChartColorLegendWidgetView
ChartColorLegendWidgetView.__filename__ = 'dashboards/widgets/chart/chart-color-legend-widget-view.js'
